// extracted by mini-css-extract-plugin
module.exports = {"ocrText":"questionText_ocrText__6OTMf"};